import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Inline, RadioButtonGroup, RadioButtonGroupItem, Text, Tooltip } from '@ui-lib';
import { useCallback } from 'react';
import { IconBuildingSvg } from 'ui-lib/src/lib/components/Icons/IconBuilding/IconBuildingSvg';
import { IconUserSvg } from 'ui-lib/src/lib/components/Icons/IconUser/IconUserSvg';

import { VALUE_PROVIDER_TOUR_CONTAINER_ID } from '../CardItemEditor/utils';
import type { ValueProvider } from '.cache/__types__';

const BuildingIcon = () => (
  <IconBuildingSvg
    style={{
      display: 'inline-block',
      height: '1.4em',
      width: '1.4em',
      overflow: 'visible',
      verticalAlign: '-0.325em',
      boxSizing: 'content-box',
    }}
  />
);

const UserIcon = () => (
  <IconUserSvg
    style={{
      display: 'inline-block',
      height: '1.4em',
      width: '1.4em',
      overflow: 'visible',
      verticalAlign: '-0.325em',
      boxSizing: 'content-box',
    }}
  />
);

type SharedIndividualSelectorProps = {
  selected: ValueProvider | undefined;
  onChange: (selectedValue: ValueProvider) => void;
};

export const SharedIndividualSelector: React.FC<SharedIndividualSelectorProps> = ({
  selected,
  onChange,
}) => {
  /**
   * This is a workaround for the fact that RadioButtonGroupItem.value is typed as a string.
   */
  const handleChange = useCallback(
    (selectedValue: string) => {
      onChange(selectedValue as ValueProvider);
    },
    [onChange],
  );

  return (
    <>
      <Box display="flex" flexDirection="column" gap="medium" marginBottom="medium">
        <Box
          id={VALUE_PROVIDER_TOUR_CONTAINER_ID}
          display="flex"
          flexDirection="column"
          gap="medium"
          width="fitContent"
        >
          <Inline alignY="center" gap="xsmall">
            <Text size="medium" weight="demibold">
              What type of field is this?
            </Text>
            <Tooltip
              position="right"
              disabled={false}
              padding="compact"
              label="Shared fields will be applied to all cards using this template, while individual ones can be added by team members."
            >
              <FontAwesomeIcon icon={faExclamationCircle} />
            </Tooltip>
          </Inline>
          <RadioButtonGroup name="example-radio-group" value={selected} onChange={handleChange}>
            <RadioButtonGroupItem icon={<BuildingIcon />} value={'template'}>
              Shared
            </RadioButtonGroupItem>
            <RadioButtonGroupItem icon={<UserIcon />} value={'member'}>
              Individual
            </RadioButtonGroupItem>
          </RadioButtonGroup>
        </Box>

        <Box>
          <Text size="small" tone="secondary">
            {selected === 'template' && (
              <>
                You (and other admins) will fill this out. It will be applied to all cards using
                this template.
              </>
            )}
            {selected === 'member' && (
              <>You or a team member will fill this out when creating a card using this template.</>
            )}
          </Text>
        </Box>
      </Box>
    </>
  );
};
